import { g as r } from "../../utils-BOfnFgIH.js";
import { I as s } from "../../constants-DeVuDy8J.js";
import { openBlock as i, createElementBlock as p, normalizeClass as d, createElementVNode as a, createStaticVNode as n } from "vue";
import { _ as f } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconDialpadSparkle",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(s).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return s[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, u = ["aria-label", "data-qa", "aria-hidden"], m = ["fill"], h = ["id"];
function _(t, e, l, v, g, o) {
  return i(), p("svg", {
    "aria-label": l.ariaLabel,
    class: d([o.iconSizeClass, "d-icon d-icon--dialpad-sparkle"]),
    "data-qa": o.dataQA,
    "aria-hidden": o.ariaHidden,
    role: "img",
    "data-name": "Dialpad Sparkle",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19 2a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0V6h-1a1 1 0 1 1 0-2h1V3a1 1 0 0 1 1-1Zm-9 2a1 1 0 0 1 .91.586l2.033 4.471 4.47 2.033a1 1 0 0 1 0 1.82l-4.47 2.033-2.033 4.47a1 1 0 0 1-1.82 0l-2.033-4.47-4.47-2.033a1 1 0 0 1 0-1.82l4.47-2.033 2.033-4.47A1 1 0 0 1 10 4Zm0 3.417-1.277 2.81a1 1 0 0 1-.497.496L5.416 12l2.81 1.277a1 1 0 0 1 .497.497L10 16.584l1.277-2.81a1 1 0 0 1 .497-.497L14.584 12l-2.81-1.277a1 1 0 0 1-.497-.497L10 7.416ZM18 16a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z",
      fill: `url(#${t.uniqueID}a)`
    }, null, 8, m),
    a("defs", null, [
      a("linearGradient", {
        id: `${t.uniqueID}a`,
        x1: "2",
        y1: "2",
        x2: "22",
        y2: "22",
        gradientUnits: "userSpaceOnUse"
      }, [...e[0] || (e[0] = [
        n('<stop stop-color="#471571"></stop><stop offset=".031" stop-color="#551B84"></stop><stop offset=".145" stop-color="#7C229E"></stop><stop offset=".237" stop-color="#9024A4"></stop><stop offset=".355" stop-color="#B02290"></stop><stop offset=".483" stop-color="#D32B86"></stop><stop offset=".603" stop-color="#E92F6F"></stop><stop offset=".701" stop-color="#F6484F"></stop><stop offset=".9" stop-color="#FB7328"></stop><stop offset=".973" stop-color="#F3960F"></stop><stop offset="1" stop-color="#F3960F"></stop>', 11)
      ])], 8, h)
    ])
  ], 10, u);
}
const b = /* @__PURE__ */ f(c, [["render", _]]);
export {
  b as default
};
//# sourceMappingURL=dialpad-sparkle.js.map
